<template>
  <v-container class="fill-height">
    <v-layout
      align-content-space-between
      fill-height
      column
      justify-space-around
    >
      <div>
        <div class="text-xs-center mt-4"><logo /></div>
        <div class="text-xs-center display-4 font-weight-bold py-4">
          Хот-спот
        </div>
        <div class="text-xs-center my-4 display-3 font-weight-bold">
          Войти в личный кабинет
        </div>

        <v-form v-model="AuthForm.formvalid" @keyup.native.enter="auth">
          <v-layout justify-center>
            <v-flex xl2 lg3 md4 sm5 xs11>
              <label>Логин или email</label>
              <v-text-field
                v-model="AuthForm.username"
                :rules="rules.username"
                :height="42"
                :autofocus="true"
                class="v-text-field--white"
                placeholder="Введите логин или email"
                autocomplete="username"
                solo
              ></v-text-field>

              <v-layout class="">
                <v-flex text-xs-left>
                  <label>Пароль</label>
                </v-flex>
                <v-flex text-xs-right>
                  <label @click="help.status = true" class="link">
                    Забыли пароль?
                  </label>
                </v-flex>
              </v-layout>

              <v-text-field
                v-model="AuthForm.password"
                :rules="rules.password"
                :height="42"
                solo
                type="password"
                class="v-text-field--white"
                placeholder="Введите пароль"
                autocomplete="current-password"
              ></v-text-field>

              <v-checkbox
                v-if="AuthForm.memorize"
                :label="'Запомнить меня'"
                v-model="AuthForm.memorize"
                onIcon=""
                offIcon=""
              ></v-checkbox>
              <v-layout justify-center>
                <v-btn
                  :disabled="!AuthForm.formvalid"
                  @click="auth"
                  class="primary user-auth__auth-btn"
                  id="auth-btn"
                >
                  Войти
                </v-btn>
              </v-layout>

              <v-alert
                v-if="error"
                icon=""
                :value="error"
                class="mt-3 mb-5 px-3 py-3 white--text"
              >
                <v-layout>
                  <icon-exclamation
                    color="#b23333"
                    textColor="#FF5B37"
                    size="22"
                    class="mr-2"
                  >
                  </icon-exclamation>
                  <span>{{ error }}</span>
                </v-layout>
              </v-alert>
            </v-flex>
          </v-layout>
        </v-form>
      </div>

      <div>
        <v-layout wrap justify-center>
          <v-flex mt-2 xl2 lg3 md4 sm5 xs12 text-xs-center>
            <div class="subtitle-2 font-weight-medium text--secondary pb-2">
              Техническая поддержка
            </div>
            <a
              href="tel:+7(800)755-0555"
              class="display-1 font-weight-bold text--primary text"
            >
              8 800 755 05 55
            </a>
          </v-flex>
          <v-flex mt-2 xl2 lg3 md4 sm5 xs12 text-xs-center>
            <div class="subtitle-2 font-weight-medium text--secondary pb-2">
              Общий номер
            </div>
            <a
              href="tel:+7(800)250-6060"
              class="display-1 font-weight-bold text--primary text"
            >
              8 800 250 60 60
            </a>
          </v-flex>
        </v-layout>
      </div>
    </v-layout>

    <v-dialog v-model="help.status" width="500">
      <div class="text-xs-right">
        <v-btn @click="help.status = false" icon small>
          <icon-close></icon-close>
        </v-btn>
      </div>
      <div class="px-3 pb-3 ma-sm-3">
        <h3 class="font-w300">НЕ МОЖЕТЕ ВОЙТИ?</h3>
        <ol class="pl-3">
          <li v-for="(advice, key) in help.advices" :key="key" class="py-2">
            {{ advice }}
          </li>
        </ol>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import IconExclamation from "../components/icon/IconExclamation.vue";
import IconClose from "../components/icon/IconClose.vue";
import Logo from "../components/common/Logo.vue";

export default {
  name: "LoginView",

  components: {
    IconClose,
    IconExclamation,
    Logo,
  },

  props: {},

  data: () => ({
    AuthForm: {
      username: "",
      password: "",
      formvalid: false,
      memorize: false,
    },
    error: "",
    rules: {
      username: [(v) => !!v || ""],
      password: [
        (v) => !!v || "",
        (v) =>
          v.search(/[а-яА-ЯёЁ]/g) === -1 || "в пароле не должно быть кириллицы",
      ],
    },
    help: {
      status: false,
      advices: [
        "Проверьте правильность ввода логина и пароля с учетом прописных и строчных букв.",
        "Если у вас нет доступа, обратитесь к администратору. Если ваш статус - администратор, обратитесь к владельцу личного кабинета.",
        "Вы можете обратиться к Персональному менеджеру по телефону 8 (800) 250-60-60, чтобы восстановить утерянные реквизиты. Реквизиты будут отправлены посредством SMS/E-mail сообщения владельцу Договора. ",
      ],
    },
  }),

  methods: {
    //авторизация
    auth() {
      this.error = "";
      if (this.AuthForm.formvalid) {
        this.$store
          .dispatch("login", {
            username: this.AuthForm.username,
            password: this.AuthForm.password,
          })
          .then(() => {
            this.$router.push({ name: "home" });
          })
          .catch((err) => {
            if (err) this.error = err;
            else this.error = "Неверный логин или пароль";
          });
      } else {
        this.error = "Укажите логин и пароль";
      }
    },
  },
};
</script>
